// Helper function to determine if a string value might be a valid date
export default function isValidDate(value) {
    if (!value || typeof value !== 'string')
        return false;
    // Attempt to create a Date object
    const date = new Date(value);
    // Check if it's a valid date
    if (Number.isNaN(date.getTime()))
        return false;
    // Check for ISO 8601 format (which includes timezone offset)
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?([+-]\d{2}:\d{2}|Z)?$/;
    if (isoRegex.test(value))
        return true;
    // Check for common date separators and formats
    const dateRegex = /^(\d{4}[-/]\d{2}[-/]\d{2}|\d{2}[-/]\d{2}[-/]\d{4}|(\d{4}|\d{2})[-/]\d{2}[-/]\d{2})$/;
    if (!dateRegex.test(value.trim()))
        return false;
    // Additional check to ensure all date parts match exactly in the correct order
    const parsedParts = date.toISOString().split('T')[0].split('-');
    const inputParts = value.split(/[-/]/);
    // Handle both YYYY-MM-DD and DD-MM-YYYY formats
    if (inputParts.length !== 3)
        return false;
    // If the first part is a 4-digit year, compare in YYYY-MM-DD order
    if (inputParts[0].length === 4) {
        return (inputParts[0] === parsedParts[0] && // Year
            inputParts[1] === parsedParts[1] && // Month
            inputParts[2] === parsedParts[2] // Day
        );
    }
    // If it's DD-MM-YYYY format, compare in reverse order
    if (inputParts[2].length === 4) {
        return (inputParts[2] === parsedParts[0] && // Year
            inputParts[1] === parsedParts[1] && // Month
            inputParts[0] === parsedParts[2] // Day
        );
    }
    return false; // Invalid format
}
